import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Home } from "lucide-react";
import SEO from "@/components/SEO";

export default function NotFound() {
  return (
    <div data-testid="page-404" className="min-h-[70vh] flex items-center bg-brand-surface">
      <SEO title="404 — Page Not Found | Carfornia Buyers" description="The page you’re looking for has taken a detour." />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <p className="font-display text-[8rem] sm:text-[12rem] font-extrabold text-brand-blue leading-none tracking-tighter">404</p>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900 mt-2">Detour ahead.</h1>
        <p className="text-slate-600 mt-4 leading-relaxed max-w-md mx-auto">
          The page you’re looking for has merged off the freeway. Let’s get you back on the road.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mt-8 justify-center">
          <Link to="/">
            <Button data-testid="404-home" className="h-12 px-7 bg-[#0052FF] hover:bg-[#0040CC] text-white font-bold rounded-xl"><Home className="w-4 h-4 mr-2" /> Back to home</Button>
          </Link>
          <Link to="/sell-your-car">
            <Button variant="outline" className="h-12 px-7 rounded-xl border-slate-200 hover:border-slate-300 font-bold">Request my offer <ArrowRight className="w-4 h-4 ml-2" /></Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
